export const EXPERIMENTS_FOR_LOGGING_EXPOSURE = [{
  treatmentKey: 'gosu-0006',
  parameter: 'group',
  treatments: ['control', 'variant_a', 'variant_b']
}];